import React, { useEffect, useState } from "react";
// import RecievedRatingData from "../admin/RecievedRatingData";
import { Link } from "react-router-dom";
// import faker from "faker";
import SmartDataTable from "react-smart-data-table";
// Import basic styling
import "react-smart-data-table/dist/react-smart-data-table.css";
import "../../../css/admin.css";
import StarRating from "./StarRating";
import { Recievdrating, RecievedRatings } from "../../../actions/auth";
import { useDispatch } from "react-redux";
import Loader from "../loader";
import { MY_PROFILE } from "../../../actions/types";
import Spinner from "../Spinner";
import "../../../css/admin.css";
import Pagination from "react-js-pagination";
const generateData = (ratinglist = 0, numTransactResults = 0) => {
  let total = numTransactResults || 0;
  if (typeof numTransactResults === "string") {
    total = parseInt(numTransactResults, 10);
  }
  const RatingsTable = [];
  for (let i = 0; i < total; i += 1) {
    //   var a = i;

    RatingsTable.push({
      NameEmail:
        ratinglist[i].userDetails.firstname +
        "--" +
        ratinglist[i].userDetails.email +
        "--" +
        ratinglist[i].userDetails.profile_image[0] +
        "--" +
        ratinglist[i]._id,
      datetime: ratinglist[i].created_at,
      Average: ratinglist[i].avg_rating,
      report: ratinglist[i].report,
      action: ratinglist[i]._id,
    });
  }
  return RatingsTable;
};

const RatingListTabs = ({ id }) => {
  const dispatch = useDispatch();
  const [RatingsTable, setRatingsTable] = useState([]);
  const [numTransactResults, setNumTransactResults] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [singlePersonRatingDetail, setSinglePersonRatingDetail] = useState("");
  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage, setItemsperpage] = useState(10);
  const [searchVal, setSearchVal] = useState("");
  const [filterVal, setFilterVal] = useState("");

  const getRecivedRating = (id) => {
    dispatch(Recievdrating(id))
      .then((res) => {
        if (res.success) {
          setSinglePersonRatingDetail(res.data);
        }
      })
      .catch((err) => console.log("errr", err));
  };

  useEffect(async () => {
    await dispatch(RecievedRatings(id, 1, "", searchVal)).then((res) => {
      console.log(res.data, "res.data...");
      if (res.data) {
        res &&
          res.data &&
          setRatingsTable(
            generateData(res.data.ratings, res.data.ratings.length)
          );
        res && res.data && setNumTransactResults(res.data.ratings.length);
        res && res.data && setTotalCount(res.data?.pagination?.totalCount);
      } else {
        setRatingsTable([]);
        setNumTransactResults("");
        setTotalCount("");
      }
    });
  }, []);

  const HandleSearch = async (e) => {
    setSearchVal(e.target.value);
    await dispatch(RecievedRatings(id, 1, "", e.target.value)).then((res) => {
      if (res.data) {
        res &&
          res.data &&
          setRatingsTable(
            generateData(res.data.ratings, res.data.ratings.length)
          );
        res && res.data && setNumTransactResults(res.data.ratings.length);
        res && res.data && setTotalCount(res.data?.pagination?.totalCount);
      } else {
        setRatingsTable([]);
        setNumTransactResults("");
        setTotalCount("");
      }
    });
  };

  const handleSelect = async (e) => {
    setFilterVal(e.target.value);
    await dispatch(RecievedRatings(id, 1, e.target.value, searchVal)).then(
      (res) => {
        if (res.data) {
          res &&
            res.data &&
            setRatingsTable(
              generateData(res.data.ratings, res.data.ratings.length)
            );
          res && res.data && setNumTransactResults(res.data.ratings.length);
          res && res.data && setTotalCount(res.data?.pagination?.totalCount);
        } else {
          setRatingsTable([]);
          setNumTransactResults("");
          setTotalCount("");
        }
      }
    );
  };

  const handlePageChange = async (pagenumber) => {
    setActivePage(pagenumber);
    await dispatch(RecievedRatings(id, pagenumber, "", searchVal)).then(
      (res) => {
        if (res.data) {
          res &&
            res.data &&
            setRatingsTable(
              generateData(res.data.ratings, res.data.ratings.length)
            );
          res && res.data && setNumTransactResults(res.data.ratings.length);
          res && res.data && setTotalCount(res.data?.pagination?.totalCount);
        } else {
          setRatingsTable([]);
          setNumTransactResults("");
          setTotalCount("");
        }
      }
    );
  };
  const calculateRange = () => {
    const currentPage = activePage;
    const itemsPerPage = 10;

    const startIndex = (currentPage - 1) * itemsPerPage + 1;

    let endIndex = currentPage * itemsPerPage;
    if (endIndex > totalCount) {
      endIndex = totalCount;
    }

    return `Showing ${startIndex} to ${endIndex} of ${totalCount} entries`;
  };
  const headers = {
    NameEmail: {
      text: "Name / Email",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        // console.log(row);
        return (
          <>
            <ul className="p-0">
              <li className="d-flex">
                <Link to="#">
                  {console.log(value, "rowwwww")}
                  <img
                    alt=""
                    src={`${MY_PROFILE}/${
                      value?.split("--")[2] 
                    }`}
                    // src={`${MY_PROFILE}/${row.profile_image[0]}`}
                    className="profilleeData"
                    onError={(e) => {
                      e.target.onerror = null; // Prevent infinite loop in case `noImage.png` also fails
                      e.target.src = "/img/noImage.png"; // Fallback image if loading fails
                    }}
                  />
                </Link>
                <div className="ml-2">
                  <h5 className="clientName">
                    <Link
                      to={`/recieved-rating-details/${value.split("--")[3]}`}
                      className="clientName"
                    >
                      <b>{value.split("--")[0]}</b>
                    </Link>
                  </h5>
                  <p className="p-0">{value.split("--")[1]}</p>
                </div>
              </li>
            </ul>
          </>
        );
      },
    },
    datetime: {
      text: "Date",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        const months = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "June",
          "July",
          "August",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        var data = new Date(value);
        var date = data.getDate();
        var Month = data.getMonth();
        var year = data.getFullYear();
        var hours = data.getHours();
        var min = data.getMinutes();
        var getMINTS = (min < 10 ? "0" : "") + min;
        var getHour = (hours < 10 ? "0" : "") + hours;
        var month = months[data.getMonth()];
        return (
          <>
            <p>
              {month}
              {date}, {year} - {getHour}:{getMINTS}h{" "}
            </p>
          </>
        );
      },
    },
    Average: {
      text: " Average",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        console.log(value, "startRatings..");
        // if (typeof value !== "number" || value < 0 || value > 5) {
        //   console.error("Invalid value for StarRating:", value);
        //   return "N/A"; // Fallback if value is invalid
        // }
        return <StarRating val={value} />;
      },
    },

    report: {
      text: "Report",
      invisible: false,
      sortable: true,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <p>{value == 0 ? "Not Reported" : "Reported"}</p>
          </>
        );
      },
    },
    action: {
      text: "Action",
      invisible: false,
      sortable: false,
      filterable: true,
      transform: (value, index, row) => {
        return (
          <>
            <span
              data-toggle="modal"
              data-target="#exampleModalCenter"
              className="edit-userbtn"
              onClick={() => getRecivedRating(value)}
            >
              <i class="fa fa-eye" aria-hidden="true"></i>
            </span>
          </>
        );
      },
    },
  };

  return (
    <div className="EventsTabs">
      {/* {console.log("single user recived rating " ,singlePersonRatingDetail)} */}
      <div className="container-fluid">
        <div>
          <Link to={`/view-user-detail/${id}`}>
            {" "}
            <i
              className="fas fa-solid fa-arrow-left"
              style={{ color: "#6a7187", marginRight: 2 }}
            />{" "}
            Back
          </Link>
        </div>
        <h1 className="events-heading mb-3">Received Ratings</h1>
        <div className="tabs-wrap">
          <ul className="ratingList mb-4">
            <li>
              <Link
                to={`/rating-list-view/${id}`}
                className="ratingLink active"
              >
                Received Ratings
              </Link>
            </li>
            <li>
              <Link to={`/given-rating/${id}`} className="ratingLink">
                Given Rating
              </Link>
            </li>
          </ul>
          <div className="recievdRating">
            <div className="container-fluid p-0">
              <div className="row pt-2">
                <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                  <div className="Search-Field">
                    <label className="form-label fields-label">Search</label>
                    <input
                      type="search"
                      className="form-control input-fields"
                      id="searchbyevent"
                      placeholder="By user name or email address"
                      onChange={HandleSearch}
                    />
                    <i className="fas fa-search search-icon"></i>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12 col-12">
                  <label className="form-label fields-label">
                    Filter by stars
                  </label>
                  <select
                    className="form-select form-control slect-field"
                    aria-label="filter"
                    placeholder="Filter by Event Status"
                    onChange={(e) => handleSelect(e)}
                  >
                    <option selected>Filter by Stars</option>
                    <option value="3">Minimum to Maximum</option>
                    <option value="4">Maximum to Minimum</option>
                  </select>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <SmartDataTable
                    data={RatingsTable}
                    responsive={true}
                    name="test-table"
                    className="ui compact selectable table eventsDataTable"
                    sortable
                    headers={headers}
                    loader={<Loader />}
                    emptyTable={
                      <div
                        style={{
                          alignItems: "center",
                          textAlign: "center",
                          marginTop: "20px",
                        }}
                      >
                        No Records Found
                      </div>
                    }
                  />
                </div>
                {RatingsTable.length > 0 && (
                  <div className="d-flex justify-content-between  mt-3">
                    <div className="my-records-number ">
                      <p style={{ color: "#000" }}>{calculateRange()}</p>
                    </div>
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={itemsPerPage}
                      totalItemsCount={numTransactResults}
                      pageRangeDisplayed={10}
                      onChange={
                        totalCount > itemsPerPage ? handlePageChange : null
                      }
                      itemClass="page-item"
                      linkClass={
                        totalCount && totalCount > 0
                          ? "page-link"
                          : "page-link disabled"
                      }
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div
            className="modal"
            id="exampleModalCenter"
            tabindex="-1"
            role="dialog"
            aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-dialog-centered modal-lg"
              role="document"
            >
              <div className="modal-content bg-light ">
                <div className="modal-header ">
                  <h5 className="modal-title" id="exampleModalLongTitle">
                    Rating Detail
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body bg-light">
                  <div>
                    {console.log("Given Detail ", singlePersonRatingDetail)}
                    {singlePersonRatingDetail !== "" ? (
                      <div>
                        <div className="jombotronShort totalAvgRating">
                          <h6 className="hhhhh">Rating Getting By</h6>
                          <p>
                            {singlePersonRatingDetail.ratingGivenBy.firstname}
                          </p>
                        </div>
                        <div className="RatingDetailClm">
                          <ul>
                            {/* basis on 0 or 1 */}
                            <li className="QuestionRating">
                              1. How did you meet valentine ?
                            </li>
                            <span className="Reply">
                              {singlePersonRatingDetail.question_one_answer ==
                              1 ? (
                                <li>Interacted and communicatd in person</li>
                              ) : (
                                <li>
                                  Didn't meet in person/communicated virtually
                                </li>
                              )}
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">
                              2. Are the picture accurate to what they looked
                              like in person ?
                            </li>
                            <span className="Reply">
                              <li>
                                <StarRating
                                  val={
                                    singlePersonRatingDetail.question_two_answer
                                  }
                                />
                              </li>
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">
                              3. Do you think they were accurate about their age
                              ?
                            </li>
                            <span className="Reply">
                              <li>
                                <StarRating
                                  val={
                                    singlePersonRatingDetail.question_three_answer
                                  }
                                />
                              </li>
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">
                              4. Do you feel they were accurate about their
                              height ?
                            </li>
                            <span className="Reply">
                              <li>
                                <StarRating
                                  val={
                                    singlePersonRatingDetail.question_four_answer
                                  }
                                />
                              </li>
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">
                              5. Do you think they are accurate about their
                              lifestyle selections ?
                            </li>
                            <span className="Reply">
                              <li>
                                <StarRating
                                  val={
                                    singlePersonRatingDetail.question_five_answer
                                  }
                                />
                              </li>
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">
                              6. Do you think this person upheld the tater
                              community guidelines ?
                            </li>
                            <span className="Reply">
                              {singlePersonRatingDetail.question_six_answer ==
                              1 ? (
                                <li>Yes</li>
                              ) : (
                                <li>No</li>
                              )}
                            </span>
                          </ul>
                          <ul>
                            <li className="QuestionRating">7. Private Note.</li>
                            <span className="Reply">
                              <li>
                                {" "}
                                {singlePersonRatingDetail.question_seven_answer}
                              </li>
                            </span>
                          </ul>
                        </div>
                        <br />
                        <div className="jombotronShort totalAvgRating">
                          <span className="text-black">
                            Total Average Rating
                          </span>
                          <span>
                            <StarRating
                              val={singlePersonRatingDetail.avg_rating}
                            />
                          </span>
                        </div>
                      </div>
                    ) : (
                      <>
                        <Spinner />
                      </>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RatingListTabs;
